import L from 'leaflet';

export class MapController {
  map: L.Map;

  curveLayer?: L.Curve;

  constructor(map: L.Map, curveLayer?: L.Curve) {
    this.map = map;
    this.curveLayer = curveLayer;
  }
}
